<template>
<nav-bar-web/>
  <div class="sectionKoko" style="background-color: ; text-align: left">
    <div class="container">
      <div class="sectionHead mt-5">
        Thank you for your interest in partnering with Koko.
      </div>
      <div class="sectionBody">Our Merchant Success team will be in contact with you shortly.</div>

    </div>
  </div>

  <FooterWeb></FooterWeb>
</template>

<script>
import NavBarWeb from "@/components/NavBarWeb";
import FooterWeb from "@/components/FooterWeb";
export default {
  name: "MerchantContactSuccess",
  components: {FooterWeb, NavBarWeb}
}
</script>

<style scoped>

.sectionHead {
  font-family: Raleway;
  font-style: normal;
  font-weight: 600;
  font-size: 35px;
  /* line-height: 42px; */

  color: #393939;

}

.sectionBody {
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  padding-top: 10px;
  padding-bottom: 10px;
  color: #393939;

  opacity: 0.8;

}
.sectionIntro {
  max-width: 500px;
}

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
}
</style>